import vxBannerCarousel from '../components/view-site-content/vx-banner-carousel/vx-banner-carousel.vue';
import VxAccordionGroup from '../components/view-site-content/vx-faq/vx-faq.vue';
import vxHeroBanner from '../components/view-site-content/vx-hero-banner/vx-hero-banner.vue';
import vxHeroBannerResponsive from '../components/view-site-content/vx-hero-banner-responsive/vx-hero-banner-responsive.vue';
import vxMarketingPromo from '../components/view-site-content/vx-marketing-promo/vx-marketing-promo.vue';
import vxImageTile from '../components/view-site-content/vx-image-tile/vx-image-tile.vue';
import VxStoreLocator from '../components/view-site-content/vx-store-locator/vx-store-locator.vue';
import vxTextTile from '../components/view-site-content/vx-text-tile/vx-text-tile.vue';
import VxImageTitle from '../components/view-site-content/vx-image-title/vx-image-title.vue';
import vxProductSupport from '../components/view-site-content/vx-product-support/vx-product-support.vue';
import vxProductSolution from '../components/view-site-content/vx-product-category-solution/vx-product-category-solution.vue';

import vxCuratedList from '../components/view-site-content/vx-curated-list/vx-curated-list.vue';
import vxBrandBar from '../components/view-site-content/vx-brand-bar/vx-brand-bar.vue';
import vxSbs from '../components/view-site-content/vx-side-by-side/vx-side-by-side.vue';
import vxImageText from '../components/view-site-content/vx-image-text/vx-image-text.vue';
import vxFeatureProduct from '../components/view-site-content/vx-feature-product/vx-feature-product.vue';
import vxProductCarousel from '../components/view-site-content/vx-product-carousel/vx-product-carousel.vue';

const viewSiteContentModule = {
  components: {
    vxHeroBanner,
    vxHeroBannerResponsive,
    vxBannerCarousel,
    VxAccordionGroup,
    vxMarketingPromo,
    vxProductSolution,
    vxProductSupport,
    vxImageTile,
    VxStoreLocator,
    vxTextTile,
    VxImageTitle,
    vxCuratedList,
    vxBrandBar,
    vxSbs,
    vxImageText,
    vxFeatureProduct,
    vxProductCarousel,
  },
};

export default viewSiteContentModule;



// WEBPACK FOOTER //
// ./src/modules/view-site-content-b2c.js